
































































































































import {EquipmentModel, JobModel, JobsApi} from "../../../apis";
import { Component, Vue, Watch } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { ACTION } from ".";
import * as FileSaver from "file-saver";
import AddJob from "./AddJob.vue";
import moment from "moment/moment";

@Component({
  components: {
    AddJob,
    MoreVertBtn,
  },
})
export default class JobMaintenanceTab extends Vue {
  searchText = "";
  showAddEditJobDialog = false;
  showDeleteJobDialog = false;
  showFinishJobDialog = false;
  selectedJob: JobModel | null = null;
  jobs: JobModel[] = [];
  mode: ACTION = ACTION.ADD;
  pagingOption: DataOptions | null = null;
  totalItems = 0;
  status = "";
  statusSelected = ["OVERDUE", "NEW", "FINISHED"];

  statusFilters = [
    {
      numberOfJob: 0,
      value: "OVERDUE",
      color: this.getColor("OVERDUE")
    },
    {
      numberOfJob: 0,
      value: "NEW",
      color:  this.getColor("NEW")
    },
    {
      numberOfJob: 0,
      value: "FINISHED",
      color: this.getColor("FINISHED")
    }
  ];

  getActions(item): Array<IAction> {
    if (item.status === 'FINISHED') {
      return [
      {
        titleName: this.$t("text.delete"),
        action: ACTION.DELETE,
        titleStyle: "color: red",
      },
    ];
    }
    return [
      {
        titleName: this.$t("text.edit"),
        action: ACTION.EDIT,
      },
      {
        titleName: this.$t("text.finishJob"),
        action: ACTION.FINISH_JOB
      },
      {
        titleName: this.$t("text.delete"),
        action: ACTION.DELETE,
        titleStyle: "color: red",
      },
    ];
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  getColor(status): string {
    switch (status) {
      case "NEW": {
        return "#00B162";
      }
      case "FINISHED": {
        return "#152235";
      }
      case "OVERDUE": {
        return "#E54949";
      }
      default: {
        return;
      }
    }
  }

  get HEADERS() {
    return [
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("text.status"),
        value: "status",
        sortable: true,
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("text.location"),
        value: "location.locationName",
        sortable: true,
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("job.jobName"),
        value: "jobName",
        sortable: true,
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("job.maintenanceDate"),
        value: "maintenanceDate",
        sortable: true,
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("job.estimatedTimeRemaining"),
        value: "estimatedTimeRemaining",
        sortable: true,
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("job.file"),
        value: "attachFileNames",
        sortable: false,
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("job.notes"),
        value: "notes",
        sortable: false,
      },
      {
        text: this.$t("locationColumn.action"),
        value: "action",
        sortable: false,
        class: ["tw-whitespace-no-wrap"],
      },
    ] as DataTableHeader[];
  }

  mounted() {
    const btnAddMaintenanceJob = document.querySelector(
      ".button-add-maintenance-job"
    ) as HTMLButtonElement;
    if (btnAddMaintenanceJob) {
      btnAddMaintenanceJob.onclick = () => {
        this.showAddEditJobDialog = true;
        this.mode = ACTION.ADD;
      };
    }
  }

  onSelectedAction(item: JobModel, action: ACTION): void {
    this.selectedJob = { ...item };
    this.selectedJob.maintenanceDate = this.selectedJob.maintenanceDate ? moment(this.selectedJob.maintenanceDate).format(
      "YYYY-MM-DD HH:mm"
    ) : null;
    this.mode = action;
    switch (action) {
      case ACTION.EDIT: {
        this.showAddEditJobDialog = true;
        break;
      }
      case ACTION.DELETE: {
        this.showDeleteJobDialog = true;
        break;
      }
      case ACTION.FINISH_JOB: {
        this.showFinishJobDialog = true;
        break;
      }
      default: {
        break;
      }
    }
  }

  onPagingOption() {
    this.doSearch();
  }

  onDownloadFile(item: JobModel, fileName: string) {
    this.$util.showLoading();
    new JobsApi()
      .downloadJobAttachFile({ id: item.id, fileName: fileName }, { responseType: "blob" })
      .then((resp) => {
        FileSaver.saveAs(resp.data as any, fileName);
        this.$util.hideLoading();
      })
      .catch((error) => {
        this.$util.showError(error);
        this.$util.hideLoading();
      });
  }

  async onDeleteJobDialog() {
    this.$util.showLoading();
    try {
      await new JobsApi().deleteJob({
        id: this.selectedJob.id,
      });
      this.showDeleteJobDialog = false;
      await this.doSearch();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

    async onFinishJobDialog() {
    this.$util.showLoading();
    try {
      await new JobsApi().finishJob({
        id: this.selectedJob.id,
      });
      this.showFinishJobDialog = false;
      await this.doSearch();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async doSearch() {
    this.$util.showLoading();
    try {
      const rs = await new JobsApi().searchJobs({
        keySearch: this.searchText,
        status: this.statusSelected.length > 0 ? this.statusSelected.join(','): '',
        page: this.pagingOption.page,
        limit: this.pagingOption.itemsPerPage,
        orderBy:
          this.pagingOption.sortBy.length > 0
            ? this.pagingOption.sortBy[0]
            : "",
        orderDesc:
          this.pagingOption.sortDesc.length > 0
            ? "" + this.pagingOption.sortDesc[0]
            : "",
      });

      this.totalItems = rs.data.count;
      this.jobs = rs.data.data;
      this.setDatafilterStatus(rs.data.numberOfOverdue, rs.data.numberOfNew, rs.data.numberOfFinish);
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  private setDatafilterStatus(numberOfOverdue, numberOfNew, numberOfFinish) {
    this.statusFilters[0].numberOfJob = numberOfOverdue;
    this.statusFilters[1].numberOfJob = numberOfNew;
    this.statusFilters[2].numberOfJob = numberOfFinish;
  }

  selectStatus(statusFilter) {
    const status = statusFilter.value;
    const indexOFStatus = this.statusSelected.indexOf(status);
    if (indexOFStatus > -1) {
      this.statusSelected.splice(indexOFStatus, 1);
    } else {
      this.statusSelected.push(statusFilter.value);
    }
    this.doSearch();
  }
}
